import React, { Component } from "react";
import { Button, notification, Spin, Empty } from "antd";
import { CustomModal } from "../common/CustomModal";
import { CustomSelect } from "../common/CustomSelect";
import { listAllDropDownCourse } from "../../Graphs/Course/listAllDropDownCourse";
import { FetchCourse } from "../../Graphs/User/FetchCourse";
import { assignCourseToUser } from "../../Graphs/User/assignCourseToUser";
import { connect } from "react-redux";

class AssignCourseModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      courseOptions: [],
      selectedCourseId: null,
      loadingCourses: false,
    };
  }

  componentDidUpdate(prevProps) {
    // Load courses when modal becomes visible
    if (this.props.visible && !prevProps.visible) {
      this.setState({ selectedCourseId: null });
      this.loadCourses();
    }
  }

  loadCourses = async () => {
    const { authToken, loginUserData } = this.props;
    const isCorporate = loginUserData && loginUserData.role === "corporate";

    this.setState({ loadingCourses: true });
    try {
      if (isCorporate) {
        // Fetch only purchased courses for this corporate group
        const res = await FetchCourse(authToken);
        if (res.status === 200) {
          const options = (res.data || []).map((item) => {
            const cInfo = item.courses || {};
            const cDetails = cInfo.courseDetails || {};
            const courseId = cInfo.course_id || cDetails._id;
            const courseName = cDetails.name || "Untitled Course";
            const assignCount = cInfo.assign_count || 0;
            const maxUsers = cInfo.max_user_count;

            let label = courseName;
            let disabled = false;

            if (maxUsers != null) {
              const availableSeats = Math.max(0, maxUsers - assignCount);
              if (availableSeats <= 0) {
                disabled = true;
                label = `${courseName} (No seats available - ${assignCount}/${maxUsers})`;
              } else {
                label = `${courseName} (${availableSeats}/${maxUsers} seats available)`;
              }
            } else {
              label = `${courseName} (Assigned: ${assignCount})`;
            }

            return {
              value: courseId,
              label: label,
              disabled: disabled,
            };
          });
          this.setState({ courseOptions: options });
        }
      } else {
        // Fetch all active courses for Super Admin / Admin / Sub Admin
        const res = await listAllDropDownCourse(authToken, 0, 1000000);
        if (res.status === 200) {
          const options = (res.data || []).map((c) => ({
            value: c._id,
            label: c.name,
          }));
          this.setState({ courseOptions: options });
        }
      }
    } catch (e) {
      console.error("Failed to load courses", e);
    } finally {
      this.setState({ loadingCourses: false });
    }
  };

  handleAssign = async () => {
    const { authToken, user, onClose, onSuccess } = this.props;
    const { selectedCourseId } = this.state;

    if (!selectedCourseId) {
      notification.warning({
        message: "Assign Course",
        description: "Please select a course first.",
      });
      return;
    }

    this.setState({ isLoading: true });
    try {
      const res = await assignCourseToUser(authToken, user._id, selectedCourseId);
      if (res.status === 200) {
        notification.success({
          message: "Assign Course",
          description: `Course has been assigned to ${user.first_name || "user"} successfully.`,
        });
        if (onSuccess) {
          onSuccess();
        }
        onClose && onClose();
      } else {
        notification.error({
          message: "Assign Course",
          description: res.message || "Something went wrong.",
        });
      }
    } catch (e) {
      notification.error({
        message: "Assign Course",
        description: typeof e === "string" ? e : "Failed to assign course.",
      });
    } finally {
      this.setState({ isLoading: false });
    }
  };

  render() {
    const { visible, onClose, user, loginUserData } = this.props;
    const { courseOptions, selectedCourseId, isLoading, loadingCourses } = this.state;
    const isCorporate = loginUserData && loginUserData.role === "corporate";
    const primaryColor = this.props.primaryColor || localStorage.getItem("primary_color") || "#4466f2";

    return (
      <CustomModal
        title={`Assign Course to ${user ? user.first_name || "User" : "User"}`}
        visible={visible}
        onCancel={onClose}
        footer={null}
        maskClosable={false}
        destroyOnClose
        bodyStyle={{ minHeight: 300 }}
      >
        <div style={{ padding: "10px 0" }}>
          {loadingCourses ? (
            <div style={{ textAlign: "center", padding: "30px" }}>
              <Spin size="large" />
            </div>
          ) : courseOptions.length === 0 ? (
            <div style={{ textAlign: "center", padding: "20px 0" }}>
              <Empty
                description={
                  isCorporate
                    ? "No purchased courses found for your Corporate Group."
                    : "No active courses available."
                }
              />
              <div style={{ marginTop: "16px" }}>
                <Button onClick={onClose} style={{ borderRadius: "6px" }}>Close</Button>
              </div>
            </div>
          ) : (
            <>
              <div style={{ marginBottom: "20px" }}>
                <div
                  style={{
                    fontSize: "13px",
                    fontWeight: 600,
                    marginBottom: "8px",
                    color: "#555",
                  }}
                >
                  Select Course
                </div>
                <CustomSelect
                  id="assign-course-select"
                  placeholder="Search and select a course..."
                  options={courseOptions}
                  value={selectedCourseId}
                  onChange={(val) => this.setState({ selectedCourseId: val })}
                  showSearch
                />
              </div>

              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  gap: "10px",
                  marginTop: "24px",
                }}
              >
                <Button
                  onClick={onClose}
                  disabled={isLoading}
                  style={{ borderRadius: "6px", fontWeight: 500 }}
                >
                  Cancel
                </Button>
                <Button
                  type="primary"
                  loading={isLoading}
                  onClick={this.handleAssign}
                  disabled={!selectedCourseId}
                  style={
                    !selectedCourseId
                      ? { borderRadius: "6px", fontWeight: 600 }
                      : {
                          backgroundColor: primaryColor,
                          borderColor: primaryColor,
                          color: "#ffffff",
                          borderRadius: "6px",
                          fontWeight: 600,
                          boxShadow: `0 2px 6px ${primaryColor}40`,
                        }
                  }
                >
                  Assign Course
                </Button>
              </div>
            </>
          )}
        </div>
      </CustomModal>
    );
  }
}

const mapStateToProps = (state) => ({
  authToken: state.auth.authToken,
  loginUserData: state.auth.loginUserData,
});

export default connect(mapStateToProps)(AssignCourseModal);
